<template>
  <div v-if="Data">
    <div class="flex-row start middle list-half bg p1">
      <div class="t1">{{ config.label }}</div>
    </div>
    <div class="p1 flex-row start middle wrap">
      <template v-if="config.query">
        <template v-if="!isedit">
          <span class="ta p1" v-if="Data[config.path + '_query']">查询</span>
        </template>
        <el-checkbox v-else v-model="Data[config.path + '_query']" @change="OnDataChange($event, config.path + '_query')"><span class="title">查询</span></el-checkbox>
      </template>
      <template v-if="config.edit">
        <template v-if="isedit">
          <el-checkbox v-model="Data[config.path + '_add']" @change="OnDataChange($event, config.path + '_add')"><span class="title">新增</span></el-checkbox>
          <el-checkbox v-model="Data[config.path + '_modify']" @change="OnDataChange($event, config.path + '_modify')"><span class="title">编辑</span></el-checkbox>
          <el-checkbox v-model="Data[config.path + '_del']" @change="OnDataChange($event, config.path + '_del')"><span class="title">删除</span></el-checkbox>
        </template>
        <template v-else>
          <span class="ta p1" v-if="Data[config.path + '_add']">新增</span>
          <span class="ta p1" v-if="Data[config.path + '_modify']">编辑</span>
          <span class="ta p1" v-if="Data[config.path + '_del']">删除</span>
        </template>
      </template>
    </div>
    <template v-if="config.acts && config.acts.length > 0">
      <div class="p1 bg">操作授权</div>
      <div class="p1 flex-row start middle wrap">
        <template v-if="isedit">
          <el-checkbox v-model="Data[act.path]" v-for="(act, index) in config.acts" :key="index" @change="OnDataChange($event, act.path)"
            ><span class="title">{{ act.label }}</span>
          </el-checkbox>
        </template>
        <template v-else>
          <span class="ta p1" v-if="Data[act.path]" v-for="(act, index) in config.acts" :key="index">{{ act.label }}</span>
        </template>
      </div>
    </template>
    <div v-if="config.children && config.children.length > 0">
      <Json_Emtity :isedit="isedit" v-for="(item, index) in config.children" :config="item" :key="index" :value="Data" class="panel" @change="OnChildChange"></Json_Emtity>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Json_Emtity',
  props: {
    config: Object,
    value: Object,
    isedit: Boolean
  },
  data() {
    return { Data: null }
  },
  methods: {
    OnDataChange(value, path) {
      this.$emit('change', { [path]: value })
    },
    OnChildChange(e) {
      this.$emit('change', e)
    }
  },
  created() {
    this.Data = Object.assign({}, this.value)
  }
}
</script>
